export default class BlockRessourceProgram {
	constructor() {

		let blocks = document.querySelectorAll('.block-ressource-program');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			new Swiper(swiper, {
				slidesPerView: 1,
				grabCursor: true,
				spaceBetween: 0,
				speed: 500,
				effect: 'creative',
				creativeEffect: {
					prev: {
						translate: [-50, 0, -50],
						opacity: 0
					},
					next: {
						translate: [50, 0, 50],
						opacity: 0
					},
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});
		});
	}
}
